import React from "react";
import { Redirect, RouteProps } from "react-router-dom";

import applicationMap from "services/applicationMap";

import BreakdownPage from "pages/JobPage/BreakdownPage/BreakdownPage";
import BreakdownPrintPage from "pages/JobPage/BreakdownPrintPage/BreakdownPrintPage";
import FollowUpPage from "pages/JobPage/FollowUpPage/FollowUpPage";
import JobPage from "pages/JobPage/JobPage";
import RolePage from "pages/JobPage/RolePage/RolePage";
import AllOpportunitiesPage from "pages/JobsPage/AllOpportunitiesPage/AllOpportunitiesPage";
import AllPaidPage from "pages/JobsPage/AllPaidPage/AllPaidPage";
import ClientAlertsPage from "pages/JobsPage/ClientAlertsPage/ClientAlertsPage";
import JobsPage from "pages/JobsPage/JobsPage";
import MatchingMyFilterPage from "pages/JobsPage/MatchingMyFilterPage/MatchingMyFilterPage";
import SelfTapeRequestNotificationsPage from "pages/JobsPage/SelfTapeRequestNotificationsPage/SelfTapeRequestNotificationsPage";
import SelfTapeRequestPage from "pages/SelfTapeRequestPage/SelfTapeRequestPage";
import SelfTapeUploadPage from "pages/SelfTapeUploadPage/SelfTapeUploadPage";
import AgentSearchPageWrapper from "pages/AgentSearchPage/AgentSearchPageWrapper";
import MySuggestions from "pages/MySuggestions";
import { BASE_PATH } from "./common";

export interface IRoute extends RouteProps {
  path: string;
  component: React.ComponentType<React.PropsWithChildren<any>>;
  routes?: IRoute[];
}

const routes: IRoute[] = [
  {
    path: BASE_PATH,
    exact: true,
    component: () => <Redirect to={applicationMap.routes.jobsMyFilters()} />,
  },
  {
    path: applicationMap.routes.agentSearch(),
    component: AgentSearchPageWrapper,
  },
  {
    path: applicationMap.routes.jobs(),
    exact: true,
    component: JobsPage,
    routes: [
      {
        path: applicationMap.routes.jobsMyFilters(),
        exact: true,
        component: MatchingMyFilterPage,
      },
      {
        path: applicationMap.routes.jobsAllPaid(),
        exact: true,
        component: AllPaidPage,
      },
      {
        path: applicationMap.routes.jobsAllOpportunities(),
        exact: true,
        component: AllOpportunitiesPage,
      },
      {
        path: applicationMap.routes.jobsClientAlerts(),
        exact: true,
        component: ClientAlertsPage,
      },
      {
        path: applicationMap.routes.jobsSelfTapeRequests(),
        exact: true,
        component: SelfTapeRequestNotificationsPage,
      },
      {
        path: applicationMap.routes.jobsMySuggestions(),
        exact: true,
        component: MySuggestions,
      },
    ],
  },
  {
    path: applicationMap.routes.job(),
    component: JobPage,
    routes: [
      {
        path: applicationMap.routes.jobBreakdown(),
        exact: true,
        component: BreakdownPage,
      },
      {
        path: applicationMap.routes.jobBreakdownPrint(),
        exact: true,
        component: BreakdownPrintPage,
      },
      {
        path: applicationMap.routes.jobRole(),
        exact: true,
        component: RolePage,
      },
      {
        path: applicationMap.routes.jobFollowUp(),
        exact: true,
        component: FollowUpPage,
      },
    ],
  },
  {
    path: applicationMap.routes.selfTapeUpload(),
    exact: true,
    component: SelfTapeUploadPage,
  },
  {
    path: applicationMap.routes.selfTapeRequest(),
    exact: true,
    component: SelfTapeRequestPage,
  },
];

export default routes;
